interface RuleIconProps extends React.HTMLAttributes<HTMLSpanElement> {
  size?: number;
}

function RuleIcon({ size = 36, className = '', onClick = (event) => {}, ...props }: RuleIconProps) {
  return (
    <span className={className} onClick={onClick} {...props}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 24 24'
        fill='currentColor'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M21.55 6.74019C21.75 6.85566 21.75 7.14434 21.55 7.25981L17.95 9.33827C17.75 9.45374 17.5 9.3094 17.5 9.07846V8.00417C16.1041 8.02938 15.3114 8.17523 14.6437 8.61301C13.8739 9.11772 13.1149 10.1153 12.0423 12.3225C12.0133 12.3822 11.9841 12.4414 11.9547 12.5C11.9841 12.5586 12.0133 12.6178 12.0423 12.6775C13.1149 14.8847 13.8739 15.8823 14.6437 16.387C15.3114 16.8248 16.1041 16.9706 17.5 16.9958V15.9215C17.5 15.6906 17.75 15.5463 17.95 15.6617L21.55 17.7402C21.75 17.8557 21.75 18.1443 21.55 18.2598L17.95 20.3383C17.75 20.4537 17.5 20.3094 17.5 20.0785V18.9966C16.0008 18.9738 14.708 18.8207 13.5471 18.0595C12.4661 17.3508 11.6101 16.1887 10.7039 14.4649C10.1831 15.0833 9.57387 15.5933 8.81969 15.9867C7.36578 16.7453 5.50305 17 3 17C2.44771 17 2 16.5523 2 16C2 15.4477 2.44771 15 3 15C5.42552 15 6.88422 14.7407 7.89459 14.2136C8.59585 13.8477 9.14686 13.3175 9.66543 12.5C9.14686 11.6825 8.59585 11.1523 7.89459 10.7864C6.88422 10.2593 5.42552 10 3 10C2.44771 10 2 9.55229 2 9C2 8.44772 2.44771 8 3 8C5.50305 8 7.36578 8.25473 8.81969 9.01326C9.57387 9.40672 10.1831 9.91668 10.7039 10.5351C11.6101 8.81126 12.4661 7.6492 13.5471 6.94046C14.708 6.17927 16.0008 6.02622 17.5 6.00343V4.92154C17.5 4.6906 17.75 4.54626 17.95 4.66173L21.55 6.74019Z'
        />
      </svg>
    </span>
  );
}

export default RuleIcon;
